// Base URL for all API and WebSocket connections
// In development, use the vite dev server port 5173
// In production, use relative URLs so they work with the worker's domain
export const API_URL = import.meta.env.DEV ? 'http://localhost:5173' : '';

// Helper to get WebSocket URL
export const getWebSocketUrl = (url: string) => url.replace('http://', 'ws://').replace('https://', 'wss://');
